import React, { Component } from 'react'
import { Card, CardBody, Form, Input, FormGroup, Label } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modTarea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            titulo: this.props.titulo,
            descripcion: this.props.descripcion,
            errors: {}
        }
        this.guardar = this.guardar.bind(this)
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch([field].toString()){
                case 'titulo':
                    if (validaciones.validar_titulo(this.state.titulo)) {
                        value = validaciones.validar_titulo(this.state.titulo)
                        this.setState(prevState => ({ errors: { ...prevState.errors, titulo: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).titulo) });
                    }
                break;
                
                case 'descripcion':
                    if (validaciones.validar_titulo(this.state.descripcion)) {
                        value = validaciones.validar_titulo(this.state.descripcion)
                        this.setState(prevState => ({ errors: { ...prevState.errors, descripcion: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).descripcion) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    guardar(e) {
        e.preventDefault()

        const { id, titulo, descripcion } = this.state

        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/updateTarea', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, titulo, descripcion })
            }).then(response => {
                this.props.actualizarLista();
                this.props.cerrar();
            }).catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 601:
                        toast.error('Este documento ya existe')
                        break;

                    case 604:
                        toast.error('Este usuario no pudo ser registrado')
                        break;

                    default:
                        break;
                }
            })
        }
    }

    render() {

        return (
            <Card className="border-0">
                <CardBody>
                    <Form onSubmit={this.guardar}>

                        <FormGroup>
                            <Label>Grupo</Label>
                            <Input type="text" name="grupo" value={this.props.nombre} disabled className="w-100" />
                        </FormGroup>
                        
                        <FormGroup>
                            <Label>Titulo</Label>
                            <Input type="text" name="titulo" onChange={this.setValue.bind(this, 'titulo')} defaultValue={this.state.titulo} className="w-100" />
                        </FormGroup>
                        
                        <FormGroup>
                            <Label>Descripcion</Label>
                            <Input type="textarea" name="mensaje" onChange={this.setValue.bind(this, 'descripcion')} defaultValue={this.state.descripcion} className="w-100" />
                        </FormGroup>

                        <Input type="submit" name="guardar" value="Guardar" className="w-100 bg-primary text-light">Enviar</Input>
                    </Form>
                </CardBody>
            </Card >
        )
    }
}
